import DevicesRepository from "@/repositories/settings/devices.js";
import OperationsRepository from "@/repositories/settings/operations.js";
import BracketsRepository from "@/repositories/settings/bracketsRepository.js";
import AgenciesRepository from "@/repositories/settings/agenciesRepository.js";
import TechniciansRepository from "@/repositories/settings/techniciansRepository.js";

export default {
  namespaced: true,
  state: {
    devices: [],
    operations: [],
    brackets: [],
    technicians: [],
    agencies: []
  },
  mutations: {
    // Set devices settings
    setDevices(state, devices) {
      state.devices = devices;
    },

    // Set operations settings
    setOperations(state, operations) {
      state.operations = operations;
    },

    // Set brackets settings
    setBrackets(state, brackets) {
      state.brackets = brackets;
    },

    // Set agencies settings
    setAgencies(state, agencies) {
      state.agencies = agencies;
    },

    // Set technicians settings
    setTechnicians(state, technicians) {
      state.technicians = technicians;
    }
  },
  actions: {
    // Fetch devices settings
    async fetchDevicesSettings({ commit }, family) {
      try {
        const { data } = await DevicesRepository.getDropdowns(family);
        commit("setDevices", data);
      } catch (error) {
        throw error;
      }
    },

    // Fetch operations settings
    async fetchOperationsSettings({ commit }) {
      try {
        const { data } = await OperationsRepository.getDropdowns();
        commit("setOperations", data);
      } catch (error) {
        throw error;
      }
    },

    // Fetch brackets settings
    async fetchBracketsSettings({ commit }) {
      try {
        const brackets = await BracketsRepository.get();
        commit("setBrackets", brackets);
      } catch (error) {
        throw error;
      }
    },

    // Fetch agencies settings
    async fetchAgenciesSettings({ commit }) {
      try {
        const agencies = await AgenciesRepository.get();
        commit("setAgencies", agencies);
      } catch (error) {
        throw error;
      }
    },

    // Fetch technicians settings
    async fetchTechniciansSettings({ commit }) {
      try {
        const technicians = await TechniciansRepository.get();
        commit("setTechnicians", technicians);
      } catch (error) {
        throw error;
      }
    }
  }
};
